import { DefaultTrigger, QueryTrigger, TriggerType } from "@app2/clients/types/alert-typedefs";

export function determineTriggerType(trigger: QueryTrigger|DefaultTrigger): TriggerType {
    if (!trigger) {
        return TriggerType.upperThreshold;
    }
    if ((<QueryTrigger>trigger).type && (<QueryTrigger>trigger).type !== "custom") {
        return (<QueryTrigger>trigger).type;
    } else if (trigger.dynamicThresholds) {
        return TriggerType.dynamicThresholds;
    } else if (trigger.temporalAnomalyDetection) {
        return TriggerType.temporalAnomalyDetection;
    } else if (trigger.everyEvent) {
        return TriggerType.everyEvent;
    } else if (trigger.minMatch !== undefined && trigger.minMatch !== null) {
        return TriggerType.lowerThreshold; // Lower thresholds can have minMatch of 0;
    } else {
        return TriggerType.upperThreshold;
    }
}
